import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const getTransaksiLayout = async (axiosInstance, urlAttribute) => {
  const keys = Object.keys(urlAttribute);
  let urlQuery = [];
  keys.forEach((key) => {
    urlQuery.push(key + "=" + urlAttribute[key]);
  });

  return await axiosInstance
    .get("opt/transaksi/view/?" + urlQuery.join("&"))
    .catch((error) => {
      console.error(error);
      toast.error(`GET (Transaksi) ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
};

export default getTransaksiLayout;
